<div class="loading fade-in"
    [style.--bar-width]="barWidth"
    [style.--bar-height]="barHeight"
    [style.--bar-background-color]="barBackgroundColor"
    >
    <div class="slider"></div>
</div>